import { TableCell } from '@mui/material'
import EditField from 'components/DocumentDetail/Editor/EditField'
import { Field } from 'components/DocumentDetail/types'

interface Props extends Field {
  defaultValue: any
  onFocus: (name: string) => void
  specialHidden?: boolean // for dateN
}

function ItemCell({ onFocus, specialHidden = false, ...field }: Props) {
  const { name } = field
  const isLongItem = /(name|etc)$/.test(name)
  const isDate = /date$/.test(name)

  const compProps = {
    ...field.compProps,
    onFocus,
  }
  return (
    <TableCell
      key={name}
      sx={{
        p: 1,
        '&:last-child': { pr: 1 },
        minWidth: isLongItem ? 240 : isDate ? 180 : 120,
        display: specialHidden ? 'none' : undefined,
      }}
    >
      <EditField {...field} compProps={compProps} hlKey={`${name}\\.`} />
    </TableCell>
  )
}
export default ItemCell
